import { ENDPOINTS, getFullUrl } from "../config";
import { OrderDetails, OrderStatus, OrderType } from "./types";

export class OnlineOrderService {
    static getToken(): string | null {
        return localStorage.getItem("token");
    }

    static async getOrderListing(
        page = 1,
        pageSize = 10,
        filters: {
            hasPrescription?: boolean;
            orderStatus?: OrderStatus;
            orderType?: OrderType;
            isLabtestOrder?: boolean;
            clinicId?: string;
            searchText?: string;
        },
        searchText?:string
    ): Promise<{
        success: boolean;
        message?: string;
        data: {
            pagination: {
                totalCount: number;
                totalPages: number;
                page: number;
                pageSize: number;
            };
            data: OrderDetails[];
        };
        
    }> {
        const filtersObj: Record<string, any> = {};
        if (filters.hasPrescription !== undefined) {
            filtersObj.hasPrescription = filters.hasPrescription;
        }
        if (filters.orderStatus) {
            filtersObj.orderStatus = filters.orderStatus;
        }
        if (filters.orderType) {
            filtersObj.orderType = filters.orderType;
        }

        if (filters.isLabtestOrder === true) {
            filtersObj.isLabtestOrder = filters.isLabtestOrder;
        }
        if (filters.clinicId !== undefined) {
            filtersObj.clinicId = filters.clinicId;
        }
        if (filters.searchText !== undefined) {
            filtersObj.searchText = filters.searchText;
        }
       

        const params = new URLSearchParams({
            page: page.toString(),
            pageSize: pageSize.toString(),
            filters: JSON.stringify(filtersObj),
        });
         if(searchText){
            params.set("searchText", searchText);
        }
        const token = this.getToken();
        const url = `${getFullUrl(ENDPOINTS.ORDERS.GETORDERLISTING)}?${params.toString()}`;
        const response = await fetch(
            url,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const data = await response.json();
        return data;
    }

    static async updateOrderByClinic(
        orderId: number,
        driverId:string,
        products: { productId: string; inwardId: string; quantity: number }[]
      ): Promise<any> {
        const token = this.getToken();
        const url = `${getFullUrl(ENDPOINTS.ORDERS.UPDATEORDERBYCLINIC)}`;
      
        const response = await fetch(url, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderId, deliveryPersonId:driverId,products }),
        });
      
        const data = await response.json();
        return data;
      }

      static async reassignDriver(
        orderId: number,
        driverId:string,
      ): Promise<any> {
        const token = this.getToken();
        const url = `${getFullUrl(ENDPOINTS.ORDERS.REASSIGNEDRIVER)}`;
      
        const response = await fetch(url, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderId, deliveryPersonId:driverId }),
        });
      
        const data = await response.json();
        return data;
      }

      static async notifyPatient(formData: FormData): Promise<any> {
        const token = this.getToken();
        const url = `${getFullUrl(ENDPOINTS.ORDERS.NOTIFYPATIENT)}`;

        console.log(token)
      
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
      
        const data = await response.json();
        return data;
      }
      
}